import React, { useMemo } from 'react';
import {
    Grid, Card, CardContent, Typography, Box, List, ListItem, ListItemButton, ListItemText
} from '@mui/material';
import { useNavigate } from 'react-router-dom';

export default function MainPage({ coins }) {
    const navigate = useNavigate();

    // Group Data Logic
    const groupedData = useMemo(() => {
        const groups = {};
        coins.forEach(coin => {
            const denom = coin.denomination || 'Uncategorized';
            const s_name = coin.series_name || 'Other';
            const s_date = coin.series_date || '';
            const series = s_date ? `${s_date} ${s_name}` : s_name;

            if (!groups[denom]) groups[denom] = new Set();
            groups[denom].add(series);
        });

        const sortOrder = [
            "Tokens", "Half Cent", "1c", "2c", "3cn", "3cs", "20c",
            "5c", "10c", "25c", "50c", "100c", "Gold", "Type"
        ];

        const getSortIndex = (denom) => {
            const index = sortOrder.findIndex(d => denom.toLowerCase() === d.toLowerCase());
            return index === -1 ? 999 : index;
        };

        const result = {};
        Object.keys(groups)
            .sort((a, b) => getSortIndex(a) - getSortIndex(b))
            .forEach(denom => {
                result[denom] = Array.from(groups[denom]).sort();
            });
        return result;
    }, [coins]);

    return (
        <Grid container spacing={3}>
            {Object.keys(groupedData).map((denom) => (
                <Grid item xs={12} sm={6} md={4} lg={3} key={denom}>
                    <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                        <Box
                            onClick={() => navigate(`/denomination/${encodeURIComponent(denom)}`)}
                            sx={{
                                p: 2,
                                bgcolor: 'primary.main',
                                color: 'primary.contrastText',
                                borderTopLeftRadius: 16,
                                borderTopRightRadius: 16,
                                cursor: 'pointer',
                                '&:hover': {
                                    bgcolor: 'primary.dark',
                                }
                            }}
                        >
                            <Typography variant="h6" align="center" sx={{ color: 'inherit', fontWeight: 700 }}>
                                {denom}
                            </Typography>
                        </Box>
                        <CardContent sx={{ flexGrow: 1, p: 1 }}>
                            <List dense disablePadding>
                                {groupedData[denom].map((series) => (
                                    <ListItem key={series} disablePadding sx={{ mb: 0.5 }}>
                                        <ListItemButton
                                            onClick={() => navigate(`/series/${encodeURIComponent(denom)}/${encodeURIComponent(series)}`)}
                                            sx={{
                                                borderRadius: 2,
                                                '&:hover': {
                                                    bgcolor: 'action.hover',
                                                    color: 'primary.main',
                                                }
                                            }}
                                        >
                                            <ListItemText
                                                primary={series}
                                                primaryTypographyProps={{
                                                    fontSize: '0.9rem',
                                                    fontWeight: 500
                                                }}
                                            />
                                        </ListItemButton>
                                    </ListItem>
                                ))}
                            </List>
                        </CardContent>
                    </Card>
                </Grid>
            ))}
        </Grid>
    );
}
